import React from "react";
import "./ArtDesignStyle.scss";
import { artDesignTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";
import CustomButton from "../Common_UI_Kit/CustomButton";
import { useNavigate } from "react-router-dom";

const ArtDesignSection = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate(`/slot-games-list`);
  };

  return (
    <section className="art-design-section">
      <div className="art-design-wrap">
        <SectionHeading>{artDesignTextContent.headingText}</SectionHeading>

        <div className="art-design-box">
          <p className="para-text">{artDesignTextContent.paraText_1}</p>

          <div className="img-wrap">
            {artDesignTextContent.content.map((item, index) => (
              <div className="img-box" key={index}>
                <img src={item.imageSrc} alt="Image" />
                <h6 className="title-text">{item.titleText}</h6>
              </div>
            ))}
          </div>

          <p className="para-text">{artDesignTextContent.paraText_2}</p>

          {/* <div className="btn-box">
            <CustomButton
              buttonType="secondary"
              label={artDesignTextContent.btnText}
              onClick={handleButtonClick}
            />
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default ArtDesignSection;
